import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { cfpFieldGroups } from '../field_group/CFPFields';
import {
  listLuminaireBrand,
  listLuminaireType
} from '../../redux/references/luminaire_actions';
import { getErrorValue } from '../../utils/utility';
import { requiredValidator } from '../field_group/validators';

export class LuminaireDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  renderOption(item) {
    return (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getLuminaireData() {
    return this.formRef.getFormData();
  }

  componentDidMount() {
    this.props.listBrand();
    this.props.listType();
  }

  render() {
    const {
      name,
      brand_id,
      type_id,
      power_required,
      cfp_value,
      cfp_unit,
      description,
      image,
    } = this.props.luminaire;
    const { ref, disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="lighting-luminaire-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="lighting-luminaire-brand"
          field="brand_id"
          componentClass="select"
          label={t('brand')}
          placeholder="Luminaire Brand"
          value={brand_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'brand_id')}
          {...customAttr}
        >
          {this.props.brands.map(brand => this.renderOption(brand))}
        </FieldGroup>
        <FieldGroup
          id="lighting-luminaire-type"
          field="type_id"
          componentClass="select"
          label={t('type')}
          placeholder="Luminaire type"
          value={type_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'type_id')}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type))}
        </FieldGroup>
        <FieldGroup
          id="lighting-luminaire-power-required"
          field="power_required"
          type="number"
          label={`${t('power (W)')}`}
          placeholder="60"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        {cfpFieldGroups({ cfp_value, cfp_unit, disabled, fieldErrors, t })}
        <FieldGroup
          id="lighting-luminaire-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

LuminaireDetail.defaultProps = {
  luminaire: {},
};

const mapStateToProps = state => ({
  brands: state.reference.luminaire.brandList,
  types: state.reference.luminaire.typeList,
});

const mapDispatchToProps = dispatch => ({
  listBrand: () => dispatch(listLuminaireBrand()),
  listType: () => dispatch(listLuminaireType()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(LuminaireDetail),
);


// WEBPACK FOOTER //
// ./src/components/light/LuminaireDetail.js